var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-wrapper relative" },
    [
      _c(
        "select",
        {
          class: {
            "cl-tertiary": _vm.options.length === 0,
            empty: !_vm.selected
          },
          attrs: {
            name: _vm.name,
            autocomplete: _vm.autocomplete,
            "aria-placeholder": _vm.placeholder,
            disabled: _vm.disabled
          },
          on: {
            focus: function($event) {
              return _vm.$emit("focus")
            },
            blur: function($event) {
              return _vm.$emit("blur")
            },
            change: function($event) {
              return _vm.$emit("change", $event.target.value)
            },
            input: function($event) {
              return _vm.$emit("input", $event.target.value)
            }
          }
        },
        [
          !_vm.selected
            ? _c(
                "option",
                { attrs: { disabled: "", selected: "", value: "" } },
                [_vm._v(_vm._s(_vm.placeholder))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.options, function(option, key) {
            return _c(
              "option",
              _vm._b(
                { key: key, domProps: { value: option.value } },
                "option",
                { selected: option.value === _vm.selected },
                false
              ),
              [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.validations
        ? _c("ValidationMessages", { attrs: { validations: _vm.validations } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }